import * as React from "react";
const SvgFilterSecondary20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M3.61 3H2v2h1.522A3.13 3.13 0 0 0 6.53 7.26 3.13 3.13 0 0 0 9.538 5H18V3H9.449a3.13 3.13 0 0 0-5.84 0Zm2.92-.11c.68 0 1.24.56 1.24 1.24 0 .68-.56 1.24-1.24 1.24-.68 0-1.24-.56-1.24-1.24 0-.68.56-1.24 1.24-1.24ZM10.39 9H2v2h8.302a3.13 3.13 0 0 0 3.008 2.26A3.13 3.13 0 0 0 16.318 11H18V9h-1.77a3.13 3.13 0 0 0-2.92-2 3.13 3.13 0 0 0-2.92 2Zm2.92-.11c.68 0 1.24.56 1.24 1.24 0 .68-.56 1.24-1.24 1.24-.68 0-1.24-.56-1.24-1.24 0-.68.56-1.24 1.24-1.24ZM5.64 15a3.13 3.13 0 0 1 2.92-2 3.13 3.13 0 0 1 2.92 2H18v2h-6.432a3.13 3.13 0 0 1-3.008 2.26A3.13 3.13 0 0 1 5.552 17H2v-2h3.64Zm4.16 1.13c0-.68-.56-1.24-1.24-1.24-.68 0-1.24.56-1.24 1.24 0 .68.56 1.24 1.24 1.24.68 0 1.24-.56 1.24-1.24Z",
      clipRule: "evenodd"
    })
  );
export default SvgFilterSecondary20Px;
